import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
  signal,
} from '@angular/core';
import { Trade } from '../trades.model';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Observable, map } from 'rxjs';
import { Lot, MarketType } from '../../bids-and-offers/lots.model';
import { Store } from '@ngrx/store';
import { TableDataState } from 'src/app/store/table-data/table-data.reducer';
import { LotsService } from 'src/app/services/lots.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { PriceTypePipe } from 'src/app/pipes/price-type.pipe';

@Component({
  selector: 'app-trades-item-laptop-desktop',
  templateUrl: './trades-item-laptop-desktop.component.html',
  styleUrls: ['./trades-item-laptop-desktop.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    PriceTypePipe,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule,
    MatDialogModule,
    MatSnackBarModule,
    MatRippleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSnackBarModule,
    MatCardModule,
    MatChipsModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatSelectModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatDividerModule,
    MatIconModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatBottomSheetModule,
    MatMenuModule,
    MatBadgeModule,
  ],
})
export class TradesItemLaptopDesktopComponent
  implements OnInit, OnChanges, AfterViewInit
{
  @Input() data: any;
  displayColumns: string[] = [
    'traded-at',

    'commodity',
    'grade',
    // 'specifications',
    'volume_value',
    'price_value',
    'delivery_type',
    'shipping',
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  // dataSource = new MatTableDataSource<Trade>();
  dataSource: MatTableDataSource<Trade> = new MatTableDataSource([]);
  activeLotId = signal<string>('');
  trades$: Observable<Trade[]>;
  searchValue: string = '';

  constructor(private lotsService: LotsService) {
    // console.log('received data', this.data)
  }

  ngOnInit(): void {
    // console.log(this.item);
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  ngOnChanges(changes: SimpleChanges): void {
    // console.log('changes', changes)
    // this.dataSource.data = changes.data.currentValue;
    if (this.dataSource.data.length === 0) {
      this.dataSource.data = [];
      // console.log('datasource', this.dataSource.data);
    }
    this.dataSource = new MatTableDataSource(changes.data.currentValue);
    // console.log('datasource', this.dataSource.data);
  }

  deliveryTypeDisplay: { [key: string]: string } = {
    Delivered: 'Dlvd.',
    'FOB Facility': 'FOB Fac.',
    'FOB Farm': 'FOB Frm.',
    // Add more mappings as needed
  };

  getDisplayValue(deliveryType: string): string {
    return this.deliveryTypeDisplay[deliveryType] || deliveryType;
  }

  isSameYear(item: Trade): boolean {
    return (
      new Date(item.ship_begin).getFullYear() ===
      new Date(item.ship_end).getFullYear()
    );
  }
}
